import { useCallback } from "react";

import * as Shared from "../../../../_shared";

export const useVoucherDescription = () => {
	const { viewModel, onSetViewModel } = Shared.Model.Context.useMarketingVoucherEditContext();

	const { description } = viewModel;

	const onSetDescription = useCallback(
		(input: string) => {
			onSetViewModel([{ key: "description", value: { ...description, value: input } }]);
		},
		[description, onSetViewModel],
	);

	return {
		description,
		onSetDescription,
	};
};
